﻿module Route

open Elmish.UrlParser
open Fable.Core
open System

let toUrl route =
    match route with
    | ToVendorAdd None ->
        "#/vendor/add"
    | ToVendorAdd (Some q) ->
        let search =
            match q.Search with
            | None -> ""
            | Some s -> "search=" + JS.encodeURI s
        let page = "page=" + (q.Page.ToString())
        let size = "size=" + (q.PageSize.ToString())
        let parms =
            [ search; page; size ]
            |> List.filter (not << String.IsNullOrWhiteSpace)
            |> String.concat "&"
        "#/vendor/add?" + parms

let stringToGuid (s : string) =
    match Guid.TryParse(s) with
    | false, _ -> Error "not a guid"
    | true, g -> Ok g

let fromUrl state =
    oneOf [
        map (fun searchOpt pageOpt sizeOpt ->
            let search =
                match searchOpt with
                | None -> None
                | Some s -> Some s
            let page =
                match pageOpt with
                | Some i -> i
                | None -> 1
            let pageSize =
                match sizeOpt with
                | Some i -> i
                | None -> 10
            ToVendorAdd (Some {
                Search = search
                Page = page
                PageSize = pageSize
            })
        )
        <| (s "vendor" <?> stringParam "add" <?> intParam "page" <?> intParam "size")
        map ( ToVendorAdd None )(s "vendor" </> s "add")
    ] state


let fromLocation location =
    parseHash fromUrl location